/**
 * @alpha
 */
export var AxisPlacement;
(function (AxisPlacement) {
    AxisPlacement["Auto"] = "auto";
    AxisPlacement["Top"] = "top";
    AxisPlacement["Right"] = "right";
    AxisPlacement["Bottom"] = "bottom";
    AxisPlacement["Left"] = "left";
    AxisPlacement["Hidden"] = "hidden";
})(AxisPlacement || (AxisPlacement = {}));
/**
 * @alpha
 */
export var PointVisibility;
(function (PointVisibility) {
    PointVisibility["Auto"] = "auto";
    PointVisibility["Never"] = "never";
    PointVisibility["Always"] = "always";
})(PointVisibility || (PointVisibility = {}));
/**
 * @alpha
 */
export var DrawStyle;
(function (DrawStyle) {
    DrawStyle["Line"] = "line";
    DrawStyle["Bars"] = "bars";
    DrawStyle["Points"] = "points";
})(DrawStyle || (DrawStyle = {}));
/**
 * @alpha
 */
export var LineInterpolation;
(function (LineInterpolation) {
    LineInterpolation["Linear"] = "linear";
    LineInterpolation["Smooth"] = "smooth";
    LineInterpolation["StepBefore"] = "stepBefore";
    LineInterpolation["StepAfter"] = "stepAfter";
})(LineInterpolation || (LineInterpolation = {}));
/**
 * @alpha
 */
export var BarAlignment;
(function (BarAlignment) {
    BarAlignment[BarAlignment["Before"] = -1] = "Before";
    BarAlignment[BarAlignment["Center"] = 0] = "Center";
    BarAlignment[BarAlignment["After"] = 1] = "After";
})(BarAlignment || (BarAlignment = {}));
/**
 * @alpha
 */
export var ScaleDistribution;
(function (ScaleDistribution) {
    ScaleDistribution["Linear"] = "linear";
    ScaleDistribution["Logarithmic"] = "log";
    ScaleDistribution["Ordinal"] = "ordinal";
})(ScaleDistribution || (ScaleDistribution = {}));
/**
 * @alpha
 */
export var ScaleOrientation;
(function (ScaleOrientation) {
    ScaleOrientation[ScaleOrientation["Horizontal"] = 0] = "Horizontal";
    ScaleOrientation[ScaleOrientation["Vertical"] = 1] = "Vertical";
})(ScaleOrientation || (ScaleOrientation = {}));
/**
 * @alpha
 */
export var ScaleDirection;
(function (ScaleDirection) {
    ScaleDirection[ScaleDirection["Up"] = 1] = "Up";
    ScaleDirection[ScaleDirection["Right"] = 1] = "Right";
    ScaleDirection[ScaleDirection["Down"] = -1] = "Down";
    ScaleDirection[ScaleDirection["Left"] = -1] = "Left";
})(ScaleDirection || (ScaleDirection = {}));
/**
 * @alpha
 */
export var GraphGradientMode;
(function (GraphGradientMode) {
    GraphGradientMode["None"] = "none";
    GraphGradientMode["Opacity"] = "opacity";
    GraphGradientMode["Hue"] = "hue";
    GraphGradientMode["Scheme"] = "scheme";
})(GraphGradientMode || (GraphGradientMode = {}));
/**
 * @alpha
 */
export var graphFieldOptions = {
    drawStyle: [
        { label: 'Lines', value: DrawStyle.Line },
        { label: 'Bars', value: DrawStyle.Bars },
        { label: 'Points', value: DrawStyle.Points },
    ],
    lineInterpolation: [
        { description: 'Linear', value: LineInterpolation.Linear, icon: 'gf-interpolation-linear' },
        { description: 'Smooth', value: LineInterpolation.Smooth, icon: 'gf-interpolation-smooth' },
        { description: 'Step before', value: LineInterpolation.StepBefore, icon: 'gf-interpolation-step-before' },
        { description: 'Step after', value: LineInterpolation.StepAfter, icon: 'gf-interpolation-step-after' },
    ],
    barAlignment: [
        { description: 'Before', value: BarAlignment.Before, icon: 'gf-bar-alignment-before' },
        { description: 'Center', value: BarAlignment.Center, icon: 'gf-bar-alignment-center' },
        { description: 'After', value: BarAlignment.After, icon: 'gf-bar-alignment-after' },
    ],
    showPoints: [
        { label: 'Auto', value: PointVisibility.Auto, description: 'Show points when the density is low' },
        { label: 'Always', value: PointVisibility.Always },
        { label: 'Never', value: PointVisibility.Never },
    ],
    axisPlacement: [
        { label: 'Auto', value: AxisPlacement.Auto, description: 'First field on the left, everything else on the right' },
        { label: 'Left', value: AxisPlacement.Left },
        { label: 'Right', value: AxisPlacement.Right },
        { label: 'Hidden', value: AxisPlacement.Hidden },
    ],
    fillGradient: [
        { label: 'None', value: GraphGradientMode.None },
        { label: 'Opacity', value: GraphGradientMode.Opacity },
        { label: 'Hue', value: GraphGradientMode.Hue },
    ],
};
//# sourceMappingURL=config.js.map